
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"fill":"currentColor","height":"18","viewBox":"0 0 24 24","width":"512","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-rule":"evenodd","fill-rule":"evenodd"}},[_c('path',{attrs:{"d":"M4.35 2C3.078 2 2 3.078 2 4.35v4.5c0 1.272 1.078 2.35 2.35 2.35h4.5c1.272 0 2.35-1.078 2.35-2.35v-4.5C11.2 3.078 10.122 2 8.85 2zM4 4.35c0-.168.182-.35.35-.35h4.5c.168 0 .35.182.35.35v4.5c0 .168-.182.35-.35.35h-4.5c-.168 0-.35-.182-.35-.35zM15.15 2c-1.272 0-2.35 1.078-2.35 2.35v4.5c0 1.272 1.078 2.35 2.35 2.35h4.5c1.272 0 2.35-1.078 2.35-2.35v-4.5C22 3.078 20.922 2 19.65 2zm-.35 2.35c0-.168.182-.35.35-.35h4.5c.168 0 .35.182.35.35v4.5c0 .168-.182.35-.35.35h-4.5c-.168 0-.35-.182-.35-.35zM2 15.15c0-1.272 1.078-2.35 2.35-2.35h4.5c1.272 0 2.35 1.078 2.35 2.35v4.5c0 1.272-1.078 2.35-2.35 2.35h-4.5C3.078 22 2 20.922 2 19.65zm2.35-.35c-.168 0-.35.182-.35.35v4.5c0 .168.182.35.35.35h4.5c.168 0 .35-.182.35-.35v-4.5c0-.168-.182-.35-.35-.35zM15.15 12.8c-1.272 0-2.35 1.078-2.35 2.35v4.5c0 1.272 1.078 2.35 2.35 2.35h4.5c1.272 0 2.35-1.078 2.35-2.35v-4.5c0-1.272-1.078-2.35-2.35-2.35zm-.35 2.35c0-.168.182-.35.35-.35h4.5c.168 0 .35.182.35.35v4.5c0 .168-.182.35-.35.35h-4.5c-.168 0-.35-.182-.35-.35z"}})])])
          )
        }
      }
    